import { cn } from '../../../../util';
import { useTranslation } from 'react-i18next';
import { CheckmarkCircleFilledIcon, CircleIcon } from '../../../../icons';
import { PayoutTypeEnum, TaxTreatmentEnum } from '@pxtra-client-lib-legacy/gen';
import { BonusIcon } from '../../../compound/dataDisplay/bonusIcon';
import { TooltipComponent } from '../../feedback';

export interface SelectionCardProps {
  item: TaxTreatmentEnum | PayoutTypeEnum;
  badge?: string;
  isSelected?: boolean;
  disabled?: boolean;
  tooltip?: string;
  onSelect?: (item: TaxTreatmentEnum | PayoutTypeEnum) => void;
}

const getCardStyles = (isSelected?: boolean, disabled?: boolean) => {
  return cn(
    'group relative h-14 p-6 flex gap-x-4 items-center bg-white border border-solid border-grey-200 rounded-xl cursor-pointer',
    'hover:border-heaven-300 hover:bg-heaven-100',
    isSelected && 'border-heaven-600 bg-heaven-100',
    disabled && 'border-grey-100 text-grey-300 hover:border-grey-100 hover:bg-white cursor-default'
  );
};

export const SelectionCard = ({
  item,
  badge,
  isSelected = false,
  disabled = false,
  tooltip,
  onSelect
}: SelectionCardProps) => {
  const { t } = useTranslation();
  return (
    <TooltipComponent title={tooltip} arrow placement="bottom">
      <div
        role="button"
        tabIndex={0}
        className={getCardStyles(isSelected, disabled)}
        onClick={() => {
          if (!disabled) onSelect?.(item);
        }}
      >
        <BonusIcon icon={item} color={disabled ? 'grey.300' : 'primary.main'} />
        <div className="flex flex-col leading-6">
          <div className="font-medium">{t(`bonus:${item}:name`)}</div>
          <div className={`${disabled ? 'text-grey-200' : 'text-grey-400'}`}>
            {t(`bonus:${item}:subtitle`)}
          </div>
        </div>
        <div className="absolute fix top-4 right-4 flex gap-x-4">
          {badge && (
            <div
              className={`${disabled ? 'bg-grey-50 text-grey-200' : 'bg-heaven-200 text-heaven-600'} rounded-full px-2 py-1 text-xs`}
            >
              {badge}
            </div>
          )}
          {isSelected ? (
            <CheckmarkCircleFilledIcon className="text-heaven-600" />
          ) : (
            <CircleIcon
              className={`${disabled ? 'text-grey-100' : 'text-grey-200 group-hover:text-heaven-600'} `}
            />
          )}
        </div>
      </div>
    </TooltipComponent>
  );
};
